var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-pc"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/geeksalon.png"),"height":"24px"},on:{"click":_vm.toHome}})])}
var staticRenderFns = []

export { render, staticRenderFns }